<template>
  <div id="main-app">
    <component :is="layout">
        <router-view :key="$route.fullPath" />
    </component>
  </div>
</template>

<script>

const default_layout = "app";
export default {
  name: "main-app",
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
  created() {
    this.$store.dispatch('checkToken');
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
